import {
    ApexChart,
    ApexNonAxisChartSeries,
    ApexAxisChartSeries,
    ApexXAxis,
    ApexDataLabels,
    ApexTitleSubtitle,
    ApexPlotOptions,
    ApexFill,
    ApexStroke,
    ApexLegend,
    ApexYAxis,
    ApexStates,
    ApexTooltip,
    ApexGrid,
    ApexTheme
} from 'ng-apexcharts';

export type ChartOptions = {
    series: ApexAxisChartSeries | ApexNonAxisChartSeries;
    chart: ApexChart;
    xaxis?: ApexXAxis;
    yaxis?: ApexYAxis;
    dataLabels?: ApexDataLabels;
    title?: ApexTitleSubtitle;
    plotOptions?: ApexPlotOptions;
    fill?: ApexFill;
    stroke?: ApexStroke;
    labels?: string[];
    legend?: ApexLegend;
    subtitle?: ApexTitleSubtitle;
    colors: any[];
    states: ApexStates;
    tooltip: ApexTooltip
    grid?: ApexGrid
    theme: ApexTheme
};


export enum ChartsConfig {
    TitleFontSize = '20px'
}

export const ChartColors = [
    "#2F4D35",
    "#559561",
    "#85c792",
    "#c2eecb"
];